<template>
<div style="margin-left: auto; margin-right: auto;  width: 100%; position: relative" id="hoodieBack">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 642 642" style="enable-background:new 0 0 642 642;" xml:space="preserve">
<g>
	<g>
		<path class="body" d="M462.49,310.57c-1.2,1.46-0.96,3.26-1.17,4.94c-2.16,17.86-1.74,35.83-1.9,53.76
			c-0.18,20.75-1.7,41.49-1.1,62.24c0.48,16.58-0.82,33.04-2.38,49.49c-0.71,7.5-3.52,14.52-6.89,21.17
			c-4.32,8.52-7.54,17.73-14.52,24.7c-2.58,0.21-5.02,1.12-7.61,1.46c-4.92,0.65-9.92,0.15-14.78,1.59
			c-11.89,3.52-24.03,3.79-36.25,2.17c-3.69-0.49-7.25-0.42-10.79,1.03c-1.65,0.67-3.58,0.85-5.4,0.89
			c-15.14,0.37-30.28-0.18-45.36-1.35c-5.73-0.45-11.28-1.58-16.72,1.11c-0.28,0.14-0.63,0.16-0.95,0.17
			c-7.78,0.27-15.55,0.3-23.34-0.14c-6.19-0.35-12.05-3.19-18.5-1.76c-7.18,1.59-14.42-0.07-21.61-0.69
			c-8.16-0.71-16.36-1.46-24.05-4.71c-1.26-0.53-2.7-0.65-4.06-0.96c-3.84-2.34-6.49-5.63-7.89-9.92c-0.27-0.82-0.4-1.76-0.9-2.42
			c-7.22-9.71-7.86-21.59-10.51-32.72c-2.6-10.9-3.99-21.94-3.56-33.37c0.97-25.5,0.83-51.04-0.6-76.55
			c-0.17-3.02-0.35-6.06-0.24-9.08c0.47-13.28-2.32-26.26-3.49-39.38c-0.07-0.79-0.25-1.49-1.01-1.9c1.06-8.6,1.23-17.32,0.29-25.82
			c-1.53-13.75-3.93-27.45-6.66-41.03c-4.13-20.55-9.02-40.95-12.68-61.6c-1.69-9.51-3.9-18.96-3.14-28.74c0,0-0.03,0.06-0.03,0.06
			c0.22-0.28,0.45-0.56,0.67-0.85c5.78-5.59,12.58-9.69,20.33-11.4c8.88-1.96,17.56-4.37,26.06-7.55c1.21-0.45,2.45-0.81,4.06-1.34
			c-2.77-1.5-2.35-3.95-2.46-6.36c-0.38-8.12,0.33-16.18,0.79-24.28c0.41-7.21,3.86-12.2,9.17-16.3c6.76-5.22,14-9.78,21.11-14.5
			c9.26-6.15,17.94-13.21,28.11-17.94c12.02-5.59,23.61-12.3,36.72-15.2c18.94-4.18,37.67-4.83,56.45,1.74
			c14.52,5.08,26.87,13.75,39.75,21.61c7.1,4.33,13.97,9.05,21.07,13.4c6.71,4.11,12.46,9.3,17.93,14.87
			c3.4,3.47,5.35,7.4,5.39,12.41c0.06,6.7,0.45,13.41,0.9,20.09c0.32,4.64-0.65,8.42-6.17,10.41c9.79,2.91,18.88,5.63,28.19,7.57
			c8.6,1.79,16.3,5.53,22.8,11.55c0.37,0.34,0.55,0.9,0.82,1.35c-0.71,0.22-0.98,0.71-1.04,1.45c-0.69,8.26-1.87,16.45-3.25,24.62
			c-2.53,14.95-5.04,29.9-7.51,44.86c-1.88,11.35-3.53,22.74-5.56,34.06c-1.48,8.27-2.16,16.63-3.3,24.94
			C464.89,298.51,460.71,304.01,462.49,310.57z"/>
		<path class="sleeve" d="M462.49,310.57c-1.79-6.56,2.4-12.05,3.23-18.14c1.13-8.31,1.81-16.67,3.3-24.94
			c2.03-11.32,3.69-22.71,5.56-34.06c2.47-14.96,4.98-29.91,7.51-44.86c1.38-8.17,2.56-16.36,3.25-24.62
			c0.06-0.73,0.33-1.23,1.04-1.45c3.1,5.12,7.34,9.35,11.19,13.85c6.62,7.75,11.55,16.42,15.23,25.87
			c2.95,7.57,6.22,14.99,10.72,21.78c6.24,9.43,9.02,20.29,13.04,30.65c10.03,25.92,18.59,52.36,27.52,78.67
			c5.28,15.56,7.77,31.97,12.75,47.61c6.54,20.54,7.4,41.89,10.18,62.95c3.18,24.04,4.3,48.25,4.61,72.49
			c0.1,8.12-0.58,16.2-1.59,24.26c-0.42,3.33-1.7,5.97-4.52,7.83c-12.59,4.85-25.67,4.95-38.89,4.15
			c-8.15-0.49-15.75-3.44-23.7-4.77c-4.64-1.88-7.26-5.49-9-10.04c-4.82-12.56-7.65-25.66-10.91-38.66
			c-5.37-21.38-10.78-42.75-16.09-64.15c-2.92-11.76-5.33-23.5-7.42-35.41c-1.82-10.39-5.07-20.54-6.94-30.98
			c-3.15-17.54-6.59-35.03-9.83-52.55C462.39,314.28,462.56,312.4,462.49,310.57z"/>
		<path class="sleeve" d="M154.73,163.14c-0.76,9.78,1.46,19.22,3.14,28.74c3.66,20.65,8.55,41.05,12.68,61.6
			c2.73,13.58,5.13,27.27,6.66,41.03c0.94,8.5,0.77,17.23-0.29,25.82c-1.23,7.85-2.64,15.68-3.64,23.57
			c-2.18,17.22-6.39,33.97-11.08,50.64c-1.52,5.39-2.36,10.99-3.34,16.52c-4.47,25.06-11.79,49.41-18.26,73.97
			c-1.84,6.99-3.68,13.97-4.93,21.1c-2.17,12.39-5.86,24.37-10.18,36.17c-1.44,3.95-3.79,7-7.73,8.68
			c-2.35,0.27-4.72,0.43-7.05,0.82c-11.26,1.87-22.59,1.21-33.87,0.55c-6.59-0.39-12.6-3.45-18.88-5.32
			c-4.54-2.71-6.7-6.68-7.1-11.99c-0.69-9.31-0.82-18.57,0.59-27.84c1.18-7.73,1.25-15.5,0.92-23.31
			c-0.35-8.21-0.56-16.44,0.52-24.64c1.31-10.01,1.19-20.08,1.28-30.14c0.04-4.79,0.46-9.5,1.58-14.15
			c2.33-9.69,3.94-19.51,5.68-29.31c0.84-4.69,1.78-9.34,3.56-13.8c4.64-11.61,6.49-24,9.98-35.92
			c6.07-20.77,12.46-41.59,21.16-61.31c13.48-30.55,26.41-61.44,43.18-90.45c3.41-5.91,7.15-11.61,11.19-17.1
			C151.65,165.49,152.79,163.86,154.73,163.14z"/>
		<path class="solid" d="M205.13,525.67c1.36,0.31,2.79,0.43,4.06,0.96c7.7,3.25,15.89,4,24.05,4.71c7.18,0.62,14.43,2.28,21.61,0.69
			c6.45-1.43,12.31,1.41,18.5,1.76c7.79,0.44,15.56,0.41,23.34,0.14c0.32-0.01,0.67-0.04,0.95-0.17c5.43-2.69,10.99-1.56,16.72-1.11
			c15.08,1.18,30.22,1.72,45.36,1.35c1.81-0.04,3.75-0.22,5.4-0.89c3.55-1.45,7.1-1.52,10.79-1.03c12.22,1.62,24.36,1.35,36.25-2.17
			c4.86-1.44,9.87-0.94,14.78-1.59c2.59-0.34,5.02-1.25,7.61-1.46c-0.02,6.27-0.06,12.53-0.06,18.8c0,3.57,0.28,7.12,0.95,10.65
			c0.79,4.18,0.06,5.34-3.75,7.05c-8.49,3.81-17.49,5.38-26.66,6.28c-30.27,2.96-60.62,4.27-91.03,3.76
			c-24.43-0.41-48.87-0.85-73.17-3.8c-7.18-0.87-14.37-1.7-21.42-3.41c-1.36-0.33-2.72-0.7-4.04-1.18
			c-9.64-3.48-10.94-5.47-10.53-15.66C205.14,541.46,205.4,533.57,205.13,525.67z"/>
		<path class="solid" d="M522.92,547.85c7.95,1.34,15.55,4.28,23.7,4.77c13.22,0.8,26.29,0.71,38.89-4.15
			c-2.78,7.82-4.09,15.88-3.81,24.18c0.21,6.37,0.38,12.75,1.44,19.05c0.37,2.21-0.4,3.48-2.47,4.22c-1.85,0.66-3.72,1.13-5.66,1.26
			c-11.54,0.82-23.07,0.69-34.56-0.82c-1.05-0.14-2.07-0.58-3.1-0.89c-3.92-1.18-5.82-3.29-5.79-7.91
			c0.1-12.93-4.15-25.06-7.93-37.23C523.39,549.51,523.16,548.68,522.92,547.85z"/>
		<path class="solid" d="M57.97,547.01c6.27,1.87,12.29,4.93,18.88,5.32c11.28,0.66,22.6,1.33,33.87-0.55
			c2.33-0.39,4.7-0.55,7.05-0.82c-5.98,12.13-10.35,24.7-9.94,38.47c0.07,2.5-0.92,3.65-3.23,4.45c-5.41,1.88-11.06,2-16.63,2.28
			c-7.86,0.4-15.8,0.65-23.47-1.76c-1.53-0.48-3.02-1.17-4.44-1.93c-1.55-0.83-2.41-2.21-2.15-4.02
			C59.86,574.65,58.84,560.83,57.97,547.01z"/>
		<path class="sleeve" d="M155.37,162.35c-0.22,0.28-0.45,0.56-0.67,0.85C154.73,162.76,154.92,162.45,155.37,162.35z"/>
	</g>
	<g>
		<path class="single_stripe" d="M205.34,533.45c7.94,7.04,17.94,8.7,27.84,10.19c19.75,2.96,39.68,4.17,59.6,5.44
			c22.46,1.43,44.9,0.87,67.33-0.3c14.86-0.77,29.73-1.76,44.49-3.8c8.41-1.16,16.94-2.22,24.54-6.56c2.49-1.42,4.6-3.16,5.34-6.1
			c-0.04,4.91-0.08,9.81-0.12,14.72c-1.28,1.13-2.51,2.33-3.85,3.38c-5.27,4.14-11.64,5.6-17.96,6.96
			c-13.21,2.84-26.65,3.94-40.12,4.74c-21.9,1.31-43.79,2.05-65.74,1.32c-20.19-0.67-40.35-1.55-60.4-4.11
			c-10.27-1.31-20.49-2.94-30.31-6.47c-3.99-1.43-7.27-4.08-11-5.95C205.05,542.42,204.51,537.92,205.34,533.45z"/>
		<path class="single_stripe" d="M527.67,563.17c15.45,7.71,31.63,8.81,48.3,5.27c2.18-0.46,4.37-1.13,5.85-3.03
			c0.04,5.55,0.09,11.1,0.13,16.65c-2.63,0.93-5.14,2.28-7.95,2.6c-14.89,1.67-29.42,0.91-42.96-6.45
			C529.91,573.2,528.79,568.19,527.67,563.17z"/>
		<path class="single_stripe" d="M58.87,561.53c0.31,1.55,1.13,2.55,2.66,3.26c5.77,2.69,11.84,4.09,18.15,4.26
			c6.7,0.18,13.37-0.02,20.02-1.17c4.55-0.79,8.73-2.32,12.65-4.66c-1.31,4.78-2.62,9.56-3.93,14.34c-7.6,5.35-16.42,6-25.26,6.46
			c-8.37,0.44-16.54-0.52-24.28-3.97C58.88,573.87,58.88,567.7,58.87,561.53z"/>
	</g>
	<g>
		<path class="double_stripe" d="M205.37,538.87c-0.66-2.93-0.76-5.86,0.08-8.78c5.47,1.97,10.84,4.16,16.61,5.25
			c18.09,3.41,36.43,4.39,54.72,5.75c15.32,1.14,30.67,1.44,46.03,1.49c27.48,0.1,54.89-1.23,82.21-4.15
			c10.06-1.08,20.22-2.11,29.37-7.1c0,3.43,0.01,6.85,0.01,10.28c-0.57-1.24-1.32-0.94-2.3-0.42c-6.39,3.41-13.39,4.72-20.43,5.85
			c-18.05,2.91-36.28,3.77-54.51,4.33c-17.17,0.53-34.33,1.04-51.53,0.42c-18.35-0.66-36.67-1.53-54.94-3.4
			C235.25,546.81,219.71,545.71,205.37,538.87z"/>
		<path class="double_stripe" d="M205.03,545.24c5.3,4.09,11.63,5.56,17.96,6.89c15.64,3.29,31.51,4.8,47.44,6.04
			c23.73,1.84,47.48,2.12,71.24,1.71c23.63-0.41,47.24-1.53,70.64-5.16c6.72-1.04,13.35-2.57,19.43-5.84
			c1.28-0.69,2.36-1.46,2.72-2.95c0.19,2.96,0.39,5.92,0.58,8.87c-2.45,1.11-4.85,2.38-7.36,3.31c-11.15,4.16-22.91,5.4-34.61,6.27
			c-17.24,1.29-34.52,2.09-51.8,2.61c-25.53,0.76-51.04-0.02-76.51-1.91c-11.4-0.85-22.79-2.06-34.07-4
			c-8.97-1.54-17.68-3.98-25.93-7.9C204.84,550.54,204.93,547.89,205.03,545.24z"/>
		<path class="double_stripe" d="M528.05,565.07c-1.13-3.42-2.41-6.8-2.82-10.41c18.71,8.6,37.88,9.56,57.48,3.42
			c-0.38,3.48-0.77,6.97-1.15,10.45c-0.32,0.02-0.66-0.01-0.96,0.07c-14.93,3.96-29.78,3.42-44.59-0.76
			C533.29,567.08,531.02,565.07,528.05,565.07z"/>
		<path class="double_stripe" d="M531.55,582.71c-0.85-2.98-1.17-6.02-1.19-9.11c1.44,0.7,2.82,1.58,4.33,2.08
			c15.41,5.07,31.02,6.64,46.9,2.31c0.88,3.25,1.09,6.57,0.89,9.92c-0.64,0.05-1.3,0.04-1.92,0.17
			C563.64,591.63,547.28,590.07,531.55,582.71z"/>
		<path class="double_stripe" d="M58.76,556.05c9.62,4.36,19.81,5.86,30.24,5.72c8.65-0.11,17.19-1.22,25.33-4.43
			c-0.52,2.97-1.4,5.81-2.82,8.48c-5.34,2.11-10.96,3.13-16.62,3.59c-11.41,0.92-22.8,1.16-33.62-3.62
			c-0.8-0.35-1.52-0.84-2.34-0.12C58.87,562.46,58.82,559.26,58.76,556.05z"/>
		<path class="double_stripe" d="M59.25,574.23c14.33,5.17,28.84,4.53,43.42,1.37c2.55-0.55,4.95-1.5,7.07-3.05
			c-0.71,3.76-1.42,7.51-2.13,11.26c-0.43-0.78,0.27-2.73-1.91-1.62c-5.31,2.7-11.19,3.22-16.95,3.65
			c-7.95,0.6-15.95,0.64-23.81-1.19c-2.07-0.48-4.06-1.27-6.09-1.91C58.85,579.89,58.42,577.03,59.25,574.23z"/>
		<path class="double_stripe" d="M205.59,525.63c-0.14,0.35-0.29,0.7-0.43,1.05c-0.12-0.38-0.23-0.76-0.35-1.13
			C205.07,525.58,205.33,525.6,205.59,525.63z"/>
		<path class="double_stripe" d="M107.41,592.13c-0.15-0.36-0.09-0.63,0.31-0.76C107.98,591.78,107.85,592.02,107.41,592.13z"/>
		<path class="double_stripe" d="M434.42,544.23c-0.07-0.09-0.13-0.17-0.2-0.26c0.06-0.01,0.13-0.03,0.19-0.04c0,0,0.13,0.15,0.13,0.15
			L434.42,544.23z"/>
		<path class="double_stripe" d="M204.62,553.63l0.11,0.18c0,0-0.14,0.16-0.14,0.16c-0.06-0.1-0.12-0.2-0.18-0.3
			C204.48,553.67,204.55,553.65,204.62,553.63z"/>
		<path class="double_stripe" d="M59.02,572.49l0.19,0.21c0,0-0.16,0.23-0.16,0.23c-0.07-0.11-0.14-0.22-0.22-0.32
			C58.89,572.57,58.95,572.53,59.02,572.49z"/>
		<path class="double_stripe" d="M581.81,576.71c-0.07-0.09-0.14-0.18-0.2-0.27c0.06-0.02,0.13-0.03,0.19-0.05c0,0,0.14,0.15,0.14,0.15
			L581.81,576.71z"/>
	</g>
</g>
<image style="overflow:visible;" class="ms-filter" width="605" height="611" xlink:href="https://www.customvarsityapparel.com.au/customize/img/jacket_design/hoodie_back.png" transform="matrix(0.9521 0 0 0.9521 31.5655 28.0462)">
</image>
</svg>

<div class="" style="display: block; fill: rgb(255, 255, 255);">
	<svg class="backShoulder_holder">
		<text dominant-baseline="central" text-anchor="middle" y="50%" x="50%" class="backShoulder_letters">{{backShoulder_letters}}</text>
	</svg>
</div>
<div class="backShoulder_logos">
	<img :src="backShoulder_logos" width="180" alt=""/>
</div>
<div class="" style="display: block; fill: rgb(255, 255, 255);">
	<svg class="backShoulderWaist_letters_holder">
		<text dominant-baseline="central" text-anchor="middle" y="50%" x="50%" class="backShoulderWaist_letters">{{backShoulderWaist_letters}}</text>
	</svg>
</div>


</div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
	name: 'HoodieJacketBack',
	created() {
		this.$store.watch( getters => getters.backShoulder_id)
		this.$store.watch( getters => getters.backShoulder_logos)
		this.$store.watch( getters => getters.backShoulder_letters)
		this.$store.watch( getters => getters.backShoulderWaist_letters)
	},
	computed: {
		...mapGetters([
			'backShoulder_id',
			'backShoulder_logos',
			'backShoulder_letters',
			'backShoulderWaist_letters',
		])
	},
}
</script>
<style scoped>

.body{fill:transparent;}
.sleeve{fill:transparent;}
.solid{fill:transparent;}
.single_stripe{fill:transparent;}
.double_stripe{fill:transparent;}
.ms-filter{mix-blend-mode: multiply;}


.backShoulder_holder {
	left: 50%;
    overflow: visible;
    position: absolute;
    text-transform: uppercase;
    top: 28%;
    transform: translate(-50%, -50%);
    width: 70%;
	-webkit-text-stroke: 5px transparent;
	
}

.backShoulder_letters {
  fill: #000;
  stroke-width: 8px;
  paint-order: stroke;
  stroke: transparent;
  display: none;
  font-size: 2.5em;	
  font-family: 'Athletic', sans-serif;
}

.backShoulder_logos {
    left: 38.5%;
    position: absolute;
    top: 32%;
    width: 40%;
	z-index: 1;
	display: none;
}	

.backShoulderWaist_letters_holder {
	left: 50%;
    overflow: visible;
    position: absolute;
    text-transform: uppercase;
    bottom: 8%;
    transform: translate(-50%, -50%);
    width: 70%;
	-webkit-text-stroke: 5px transparent;
}

.backShoulderWaist_letters {
  fill: #000;
  stroke-width: 8px;
  paint-order: stroke;
  stroke: transparent;
  display: none;
  font-size: 2em;	
  font-family: 'Athletic', sans-serif;
}

</style>